module.exports = __webpack_public_path__ + "static/media/banner-101.d8a27958.jpg";